export default "__VITE_ASSET__C4UX3RO3__"